import { Box, Heading, Stack, Text } from '@chakra-ui/react'
import React from 'react'
import Button from '../../components/Button'

const links = [
  { name: 'email', label: 'E-mail 信箱' },
  { name: 'line', label: 'Line 聯絡' },
]

const ContactLinks = ({ action, description, isPreview, isEditing }) => {
  return (
    <Stack p="4" w="full" textAlign="center" spacing={6}>
      <Stack>
        <Heading size="lg">合作洽詢</Heading>
        {(description || isPreview || isEditing) && <Text opacity={!description && 0.5}>{description || '--可以輸入簡短敘述--'}</Text>}
      </Stack>
      <Stack>
        {links.map(({ name, label }) => {
          const isActive = action?.[`${name}Active`]
          return (isActive || isPreview || (isActive && isEditing)) && (
            <Button
              name={name}
              href={`${name === 'email' ? 'mailto:' : ''}${action?.[name] ?? ''}`}
              isExternal
              colorScheme="primary"
              isDisabled={!isActive}
            >{label}</Button>
          )
        })}
      </Stack>
    </Stack>
  )
}

export default ContactLinks
